import { Box, Container } from '@qga/roo-ui/components';

import htmlToReact from '@shared/v2/utils/htmlToReact';

import Disclosure from '@/components/Disclosure';
// Legacy files
import Text from '@/components/Text';
import usePropertyContent from '@/hooks/usePropertyContent';

const HotelPolicies = () => {
  const propertyContent = usePropertyContent();

  return (
    <Container>
      <Disclosure headerTitle="Hotel policies" expand variant="large">
        <Box width={[null, null, '75%']}>
          <Text lineHeight={['28px', null, '24px']}>
            {htmlToReact(propertyContent.checkInInstructions)}
          </Text>
        </Box>
      </Disclosure>
    </Container>
  );
};

export default HotelPolicies;
